import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/landing";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="bg-cream" data-id="element-90" data-mp="1hdukw8kiel4z">
      <div className="mx-auto grid max-w-6xl gap-5 px-5 py-12 md:px-8 md:py-24 lg:grid-cols-[0.7fr_1.3fr] lg:gap-20" data-id="element-91" data-mp="1ceqd9md8gvgr">
        <div data-id="element-92" data-mp="2a2ic0krxw4qg">
          <p className="text-sm font-semibold text-wine" data-id="element-93" data-mp="2a176afexomwp">Dudas comunes</p>
          <h2 className="mt-2 font-display text-[28px] text-forest md:mt-3 md:text-5xl" data-id="element-94" data-mp="252m96ouzajch">Preguntas frecuentes</h2>
        </div>
        <ul className="border-t border-line" data-id="element-95" data-mp="202rh4hzgvnpu">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="border-b border-line" data-id="element-96" data-mp="1v7c41s9a9vuh" data-mpi={i}>
                <h3 data-id="element-97" data-mp="opp3nvsnze9w">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-3.5 text-left text-[15px] font-semibold text-forest focus:outline-none focus-visible:text-wine md:gap-6 md:py-5 md:text-[17px]" data-id="element-98" data-mp="omt1twdp45g6">
                    {f.q}
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors duration-150 ${isOpen ? "bg-forest text-goldSoft" : "bg-paper text-gold ring-1 ring-line"}`} data-id="element-99" data-mp="1fnc9hwnms22t">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden data-id="element-100" data-mp="s0dt0yzigu4w" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-101" data-mp="iz6abp9ha1vx">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-102" data-mp="myokbpzrgsjz">
                      <p className="pb-4 pr-10 text-sm leading-relaxed text-muted md:pb-6 md:text-base" data-id="element-103" data-mp="2az1zdw087kp2">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}